import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import {
	Button, Chip, Collapse, Divider, Drawer,
	FormControlLabel, Radio, RadioGroup, Slider,
	TextField, Typography, Checkbox, Card, Grid, FormControl,
	FormGroup, FormLabel, Switch, CardHeader, CardContent,
	ToggleButton, ToggleButtonGroup, Autocomplete
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import _ from 'underscore';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useRouter from 'utils/useRouter';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import DataTable from '../../../../../../components/DataTable/DataTable.js';
import {
	SetFormState
} from '../../../../actions/MapDriveTestsActionsGeneric';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}));

const SummaryDialogFormGeneric = (props) => {
	const { className, ...rest } = props;
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.mapDriveTestsReducer.formState);

	const selectedDates = useSelector(state => state.mapDriveTestsReducer.selectedDates);
	const drivetestSummaryDropdown = useSelector(state => state.mapDriveTestsReducer.drivetestSummaryDropdown);
	const drivetestSummary = useSelector(state => state.mapDriveTestsReducer.drivetestSummary);

	// Map compare
	const selectedDatesCompare = useSelector(state => state.mapDriveTestsReducer.selectedDatesCompare);
	const drivetestSummaryCompare = useSelector(state => state.mapDriveTestsReducer.drivetestSummaryCompare);

	useEffect(() => {
		// dispatch(GetDriveTestSummaryDropdown());
	}, []);

	const cardStyle = {
		// height: '10vh'
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'date',
				label: 'Date',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'city',
				label: 'City',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'scenario',
				label: 'Scenario',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'kpis',
				label: 'KPIs',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'values',
				label: 'Values',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		expandableRows: false, // Try Adding This
	});

	return (
		<Card style={cardStyle}>
			<div className={classes.content}>
				<div className={classes.contentSection}>
					<Grid container spacing={1}>
						<Grid item md={4} xs={4}>
							<SelectField
								id="scenario"
								name="scenario"
								hintText="Scenario"
								menuItems={drivetestSummaryDropdown || []}
								// onChange={_handleChangeScenario}
								value={formState.values.scenario || ''}
							// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={1}>
						<Grid item md={formState.values.mapCompare ? 6 : 12}>
							<DataTable
								id="voiceDataTble"
								title=""
								data={drivetestSummary}
								columns={_getTableColumns()}
								rowsPerPage={10}
								tableBodyMaxHeight="30em"
								tableBodyCellMaxWidth="250"
								options={_getTableOptions()}
							/>
						</Grid>
						<Grid item md={6} xs={6} hidden={!formState.values.mapCompare}>
							<DataTable
								id="voiceDataTbleCompare"
								title=""
								data={drivetestSummaryCompare}
								columns={_getTableColumns()}
								rowsPerPage={10}
								tableBodyMaxHeight="30em"
								tableBodyCellMaxWidth="250"
								options={_getTableOptions()}
							/>
						</Grid>
					</Grid>
				</div>
			</div>
		</Card>
	);
};

SummaryDialogFormGeneric.propTypes = {
	className: PropTypes.string,
};

export default SummaryDialogFormGeneric;
